import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ResourcesPage = () => {
  return (
    <div className="min-h-screen bg-dark text-beige-light font-sans">
      <Navbar />
      <main>
        <section className="pt-32 pb-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-dark-card border border-dark-border rounded-2xl flex items-center justify-center">
              <i className="ri-folder-3-line text-3xl text-emerald"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-emerald">Kaynaklar</span>
            </h1>
            <p className="text-beige text-lg max-w-2xl mx-auto">
              Algoritmik karar sistemleri ve finansal teknoloji hakkında faydalı kaynaklar, dökümanlar ve rehberler.
            </p>
            <div className="mt-12 bg-dark-card border border-dark-border rounded-2xl p-12">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-tools-line text-2xl text-emerald/60"></i>
              </div>
              <p className="text-beige text-base">
                Bu sayfa yakında detaylı içeriklerle güncellenecektir.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ResourcesPage;
